import { registerDecorator } from 'class-validator';
const TAX_NUMBER_REGEX = /^(?=[0-9/]{10,13}$)\d+(?:\/\d+)*$/;
export function isTaxNumberValid(value) {
    return TAX_NUMBER_REGEX.test(value);
}
export function IsValidTaxNumber(validationOptions) {
    return function (object, propertyName) {
        registerDecorator({
            name: 'isValidTaxNumber',
            target: object.constructor,
            propertyName,
            options: { message: 'Steuernummer is not valid', ...validationOptions },
            validator: {
                validate(value) {
                    return typeof value === 'string' && isTaxNumberValid(value);
                },
            },
        });
    };
}
//# sourceMappingURL=tax-number.js.map